import React from "react";
import {Navigate, Outlet, useLocation} from "react-router-dom";
import {useAuth} from "../contexts/AuthContext";
import {UserRole} from "../api/user";

interface PrivateRouteProps {
  roles?: UserRole[];
  children?: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({roles, children}) => {
  const {isAuthenticated, user, loading} = useAuth();
  const location = useLocation();

  if (loading) {
    // Show a loading indicator while checking authentication
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" state={{from: location}} replace />;
  }

  // Check if route requires specific roles
  if (roles && roles.length > 0) {
    const hasRequiredRole = user && roles.includes(user.role as UserRole);
    if (!hasRequiredRole) {
      // Redirect to unauthorized or home page if user doesn't have required role
      return <Navigate to="/dashboard" replace />;
    }
  }

  // Render the protected component
  return children ? <>{children}</> : <Outlet />;
};

export default PrivateRoute;
